import { IEntryRepository, PresenterFunc, UpdaterFunc } from '@/core/interface';
import { EntryService } from '@/core/usecase';
import { Entry } from '@/core/entity';

export class EntryController {
  private readonly entryService: EntryService;

  constructor(entryRepository: IEntryRepository) {
    this.entryService = new EntryService(entryRepository);
  }

  public approve(
    ids: string[],
    presenter: PresenterFunc<Entry[] | null>,
    updater?: UpdaterFunc,
  ) {
    return this.entryService.approveEntries(ids, presenter, undefined, updater);
  }

  public reviewerUpdate(
      id: string,
      currPrice: number,
      noteAuditor: string,
      isOos: boolean,
      isPromo: boolean,
      presenter: PresenterFunc<Entry | null>,
      updater?: UpdaterFunc,
  ) {
    const input = {
      id,
      currPrice,
      noteAuditor,
      isOos,
      isPromo
    };
    return this.entryService.reviewerUpdate(input, presenter, undefined, updater);
  }

  public updatePrice(
    id: string,
    price: number,
    presenter: PresenterFunc<Entry | null>,
    updater?: UpdaterFunc,
  ) {
    const input = {
      id,
      currPrice: price,
    };
    return this.entryService.updateEntry(input, presenter, undefined, updater);
  }
}
